import { get } from 'lodash-es';
import { ActionStatus } from '../../constants/api';
import { ActionType } from '../../constants/redux';
import { SetRedirectUrl } from '../types';
import {
	LoginState,
	SetUserNameText,
	SetPasswordText,
	PreCheckUser,
	LoginUser,
	SetOtpText,
	ValidateOtp,
	BackPreCheck,
	ResetForm,
	ResendOTP,
	SetupPin,
	NavigateCode,
	ChangeNextView,
	ValidateEmail,
	ResetTimer,
	AcceptTNC,
	SetCaptchaToken
} from './types';
import { TNC_RESPONSE } from '../../utils/constant';

const InitialState: LoginState = {
	captchaToken: '',
	nextView: '',
	currentNonce: '',
	userNameText: '',
	passwordText: '',
	preCheckStatus: ActionStatus.NONE,
	loginStatus: ActionStatus.NONE,
	otp: '',
	otpStatus: ActionStatus.NONE,
	resndOtpStatus: ActionStatus.NONE,
	otpError: '',
	pinStatus: ActionStatus.NONE,
	pinError: '',
	location: '',

	codeStatus: ActionStatus.NONE,
	codeError: '',

	display_message: '',
	action_message: '',
	action_time: 0,

	tncStatus: ActionStatus.NONE,
	tncError: '',
	tncUpdated: false,
	tncContent: '',
	tncSkipCount: 0
};
/**
 * Breadcrumb reducer.
 * @param {BreadCrumbState} state - Breadcrumb state.
 * @param {ChangeBreadCrumbAction} action - One of Breadcrumb actions
 * @returns {BreadCrumbState} Breadcrumb state object.
 */
const LoginReducer = (state = InitialState, action: ActionType): LoginState => {
	switch (action.type) {
		case SetRedirectUrl.name: {
			return { ...InitialState, nextView: 'LOGIN' };
			// const nonce = get(TNC_RESPONSE, 'nonce', '');
			// const next = get(TNC_RESPONSE, 'next', '');
			// const updated = get(TNC_RESPONSE, 'terms.updated', false);
			// const content = get(TNC_RESPONSE, 'terms.content', '');
			// const tncSkipDays = get(TNC_RESPONSE, 'terms.tncSkipDays', 0);
			// if (next === 'TNC') {
			// 	return {
			// 		...InitialState,
			// 		nextView: 'TNC',
			// 		currentNonce: nonce,
			// 		tncUpdated: updated,
			// 		tncContent: atob(content),
			// 		tncSkipCount: tncSkipDays
			// 	};
			// } else {
			// 	return { ...InitialState, nextView: 'TNC', currentNonce: nonce };
			// }
		}
		case SetCaptchaToken.name: {
			const { payload } = action;
			return {
				...state,
				captchaToken: payload
			};
		}
		case SetUserNameText.name: {
			const { payload } = action;
			return {
				...state,
				userNameText: payload,
				display_message: '',
				action_message: ''
			};
		}
		case SetPasswordText.name: {
			const { payload } = action;
			return {
				...state,
				passwordText: payload,
				display_message: '',
				action_message: ''
			};
		}
		case SetOtpText.name: {
			const { payload } = action;
			return {
				...state,
				otp: payload,
				otpError: '',
				display_message: '',
				action_message: ''
			};
		}
		case BackPreCheck.name: {
			return {
				...state,
				currentNonce: '',
				nextView: 'LOGIN',
				display_message: '',
				action_message: ''
			};
		}

		case PreCheckUser.name: {
			return {
				...state,
				preCheckStatus: ActionStatus.LOADING,
				display_message: '',
				action_message: ''
			};
		}
		case PreCheckUser.success: {
			const { data } = action.payload;
			const nonce = get(data, 'nonce', '');
			const next = get(data, 'next', '');
			return {
				...state,
				preCheckStatus: ActionStatus.SUCCESS,
				currentNonce: nonce,
				nextView: next,
				display_message: '',
				action_message: ''
			};
		}
		case PreCheckUser.failure: {
			// const response = action.payload;
			const { response } = action.payload;
			const status = get(response, 'status', 0);
			// const data = get(response, 'data.code', '');
			const display_message = get(response, 'data.display_message', '');
			const action_message = get(response, 'data.action_message', '');
			if (status >= 500) {
				return {
					...state,
					preCheckStatus: ActionStatus.FAILURE,
					display_message: 'Alert!!',
					action_message: 'Unexpected error. Please try again or contact support'
				};
			}

			return {
				...state,
				preCheckStatus: ActionStatus.FAILURE,
				display_message,
				action_message
			};
		}

		case LoginUser.name: {
			return {
				...state,
				loginStatus: ActionStatus.LOADING,
				display_message: '',
				action_message: ''
			};
		}
		case LoginUser.success: {
			const { data } = action.payload;
			const nonce = get(data, 'nonce', '');
			const next = get(data, 'next', '');
			return {
				...state,
				loginStatus: ActionStatus.SUCCESS,
				currentNonce: nonce,
				nextView: next,
				display_message: '',
				action_message: ''
			};
		}
		case LoginUser.failure: {
			const { response } = action.payload;
			const status = get(response, 'status', 0);
			// const data = get(response, 'data.code', '');
			const display_message = get(response, 'data.display_message', '');
			const action_message = get(response, 'data.action_message', '');
			if (status >= 500) {
				return {
					...state,
					loginStatus: ActionStatus.FAILURE,
					display_message: 'Alert!!',
					action_message: 'Unexpected error. Please try again or contact support'
				};
			}
			return {
				...state,
				loginStatus: ActionStatus.FAILURE,
				display_message,
				action_message
			};
		}

		case ValidateOtp.name: {
			return {
				...state,
				otpStatus: ActionStatus.LOADING,
				display_message: '',
				action_message: ''
			};
		}
		case ValidateOtp.success: {
			const { data } = action.payload;
			const nonce = get(data, 'nonce', '');
			const next = get(data, 'next', '');
			return {
				...state,
				otpStatus: ActionStatus.SUCCESS,
				currentNonce: nonce,
				nextView: next,
				display_message: '',
				action_message: ''
			};
		}
		case ValidateOtp.failure: {
			// const response = action.payload;
			const { response } = action.payload;
			const { nextView } = state;
			const status = get(response, 'status', 0);
			const display_message = get(response, 'data.display_message', '');
			const action_message = get(response, 'data.action_message', '');
			if (status >= 500) {
				return {
					...state,
					otpStatus: ActionStatus.FAILURE,
					display_message: 'Alert!!',
					action_message: 'Unexpected error. Please try again or contact support'
				};
			}
			return {
				...state,
				otpStatus: ActionStatus.FAILURE,
				display_message,
				action_message,
				nextView: status === 400 ? 'EXP' : nextView
			};
		}

		case ResendOTP.name: {
			return {
				...state,
				resndOtpStatus: ActionStatus.LOADING,
				display_message: '',
				action_message: ''
			};
		}
		case ResendOTP.success: {
			const { data } = action.payload;
			const nonce = get(data, 'nonce', '');
			return {
				...state,
				resndOtpStatus: ActionStatus.SUCCESS,
				currentNonce: nonce,
				display_message: '',
				action_message: ''
			};
		}
		case ResendOTP.failure: {
			// const response = action.payload;
			const { response } = action.payload;
			const status = get(response, 'status', 0);
			const { nextView } = state;
			const display_message = get(response, 'data.display_message', '');
			const action_message = get(response, 'data.action_message', '');
			if (status >= 500) {
				return {
					...state,
					resndOtpStatus: ActionStatus.FAILURE,
					display_message: 'Alert!!',
					action_message: 'Unexpected error. Please try again or contact support'
				};
			}
			return {
				...state,
				resndOtpStatus: ActionStatus.FAILURE,
				display_message,
				action_message,
				nextView: status === 400 ? 'EXP' : nextView
			};
		}

		case SetupPin.name: {
			return {
				...state,
				pinStatus: ActionStatus.LOADING,
				display_message: '',
				action_message: ''
			};
		}
		case SetupPin.success: {
			const { data } = action.payload;
			const nonce = get(data, 'nonce', '');
			const next = get(data, 'next', '');
			if (next === 'TNC') {
				const updated = get(data, 'terms.updated', false);
				const content = get(data, 'terms.content', '');
				const tncSkipDays = get(data, 'terms.skipExpiryDays', 0);
				return {
					...state,
					pinStatus: ActionStatus.SUCCESS,
					currentNonce: nonce,
					nextView: next,
					display_message: '',
					action_message: '',
					tncUpdated: updated,
					tncContent: atob(content),
					tncSkipCount: tncSkipDays
				};
			}
			return {
				...state,
				pinStatus: ActionStatus.SUCCESS,
				currentNonce: nonce,
				nextView: next,
				display_message: '',
				action_message: ''
			};
		}
		case SetupPin.failure: {
			// const response = action.payload;
			const { response } = action.payload;
			const status = get(response, 'status', 0);
			const { nextView } = state;
			const display_message = get(response, 'data.display_message', '');
			const action_message = get(response, 'data.action_message', '');
			if (status >= 500) {
				return {
					...state,
					pinStatus: ActionStatus.FAILURE,
					display_message: 'Alert!!',
					action_message: 'Unexpected error. Please try again or contact support'
				};
			}
			return {
				...state,
				pinStatus: ActionStatus.FAILURE,
				display_message,
				action_message,
				nextView: status === 400 ? 'EXP' : nextView
			};
		}

		case AcceptTNC.name: {
			return {
				...state,
				tncStatus: ActionStatus.LOADING,
				display_message: '',
				action_message: ''
			};
		}
		case AcceptTNC.success: {
			const { data } = action.payload;
			const nonce = get(data, 'nonce', '');
			const next = get(data, 'next', '');
			if (next === 'INIT') {
				return { ...InitialState, nextView: 'LOGIN' };
			}
			return {
				...state,
				tncStatus: ActionStatus.SUCCESS,
				currentNonce: nonce,
				nextView: next,
				display_message: '',
				action_message: ''
			};
		}
		case AcceptTNC.failure: {
			// const response = action.payload;
			const { response } = action.payload;
			const status = get(response, 'status', 0);
			const { nextView } = state;
			const display_message = get(response, 'data.display_message', '');
			const action_message = get(response, 'data.action_message', '');
			if (status >= 500) {
				return {
					...state,
					tncStatus: ActionStatus.FAILURE,
					display_message: 'Alert!!',
					action_message: 'Unexpected error. Please try again or contact support'
				};
			}
			return {
				...state,
				tncStatus: ActionStatus.FAILURE,
				display_message,
				action_message,
				nextView: status === 400 ? 'EXP' : nextView
			};
		}

		case NavigateCode.name: {
			return {
				...state,
				codeStatus: ActionStatus.LOADING,
				display_message: '',
				action_message: ''
			};
		}
		case NavigateCode.success: {
			const { data } = action.payload;
			const redirect_url = get(data, 'redirect_url', '');
			return {
				...state,
				codeStatus: ActionStatus.SUCCESS,
				location: redirect_url,
				action_message: '',
				display_message: ''
			};
		}
		case NavigateCode.failure: {
			// const response = action.payload;
			const { response } = action.payload;
			const status = get(response, 'status', 0);
			const display_message = get(response, 'data.display_message', '');
			const action_message = get(response, 'data.action_message', '');
			if (status >= 500) {
				return {
					...state,
					codeStatus: ActionStatus.FAILURE,
					display_message: 'Alert!!',
					action_message: 'Unexpected error. Please try again or contact support',
					nextView: 'EXP'
				};
			}
			return {
				...state,
				codeStatus: ActionStatus.FAILURE,
				display_message,
				action_message,
				nextView: 'EXP'
			};
		}

		case ValidateEmail.name: {
			return {
				...state,
				pinStatus: ActionStatus.LOADING,
				action_message: '',
				display_message: '',
				action_time: 0
			};
		}
		case ValidateEmail.success: {
			const { data } = action.payload;
			const nonce = get(data, 'nonce', '');
			// const next = get(data, 'next', '');
			return {
				...state,
				currentNonce: nonce,
				pinStatus: ActionStatus.SUCCESS,
				action_message: '',
				display_message: '',
				action_time: new Date().getTime()
			};
		}
		case ValidateEmail.failure: {
			// const response = action.payload;
			const { response } = action.payload;
			const status = get(response, 'status', 0);
			const { nextView } = state;
			const display_message = get(response, 'data.display_message', '');
			const action_message = get(response, 'data.action_message', '');
			if (status >= 500) {
				return {
					...state,
					pinStatus: ActionStatus.FAILURE,
					display_message: 'Alert!!',
					action_message: 'Unexpected error. Please try again or contact support'
				};
			}
			return {
				...state,
				pinStatus: ActionStatus.FAILURE,
				display_message,
				action_message,
				nextView: status === 400 ? 'EXP' : nextView
			};
		}

		case ChangeNextView.name: {
			const { payload } = action;
			return {
				...state,
				nextView: payload,
				pinStatus: ActionStatus.NONE,
				action_message: '',
				display_message: ''
			};
		}

		case ResetTimer.name: {
			return {
				...state,
				action_time: 0
			};
		}

		case ResetForm.name: {
			const { payload } = action;
			return { ...InitialState, nextView: payload };
		}

		default:
			return state;
	}
};

export default LoginReducer;
